import { Icon16InfoOutline } from '@vkontakte/icons';
import { ReactComponent as IconClose } from 'img/icons/remove.svg';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { MAIL_HOST } from 'reactApp/modules/attaches/attaches.constants';
import { Tooltip } from 'reactApp/ui/Tooltip/Tooltip';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';

import styles from './AttachesTooltip.css';

export const AttachesTooltip = () => {
    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen((value) => !value);
    };

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const offset = useMemo(() => {
        return { x: 122, y: -30 };
    }, []);

    return (
        <>
            <div className={styles.info} onClick={handleClick} ref={ref}>
                Быстрый доступ к вложениям из писем
                <Icon16InfoOutline className={styles.infoIcon} />
            </div>
            {isOpen && (
                <Tooltip
                    theme="octavius"
                    onClose={handleClose}
                    target={ref.current}
                    placement={tooltipPlacements.BOTTOM_LEFT}
                    offset={offset}
                >
                    <div className={styles.tooltipRoot}>
                        <div className={styles.tooltipClose} onClick={handleClose}>
                            <IconClose />
                        </div>
                        <div className={styles.tooltipContent}>
                            Исходные файлы хранятся в Почте, удалить их можно только вместе с письмом через раздел для{' '}
                            <a className={styles.tooltipLink} target="_blank" href="/promo/quota/#cleaner" rel="noreferrer">
                                очистки хранилища
                            </a>{' '}
                            или в{' '}
                            <a className={styles.tooltipLink} target="_blank" href={`https://${MAIL_HOST}/inbox/`} rel="noreferrer">
                                Почте Mail.ru
                            </a>
                        </div>
                    </div>
                </Tooltip>
            )}
        </>
    );
};
